import React from 'react'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'

interface DropReasonProps {
	required?: boolean
	dropReason: string
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

export const WITHDRAWAL_REASONS = [
	'Unknown',
	'Accepted an outside/unrelated employment opportunity',
	'Arrested, on trial or incarcerated',
	'Challenge with government benefit/social assistance',
	'Change in child or other dependent care',
	'Conflict or change in work schedule',
	'Death of a family member',
	'Deceased',
	'Decided the program wasn’t for them',
	'Discharged due to unsatisfactory performance',
	'Extended illness (participant or family member)    ',
	'Financial difficulties',
	'Military activation or relocation (participant or family member)',
	'No call/no show (additional information unavailable)',
	'Relocation',
	'Transportation challenges',
	'Withdrew before start of training',
]

const DropReason: React.FC<DropReasonProps> = (props: DropReasonProps) => {
	const { dropReason, onChange, required } = props

	return (
		<OutcomeDropDownItem
			label="Drop Out Reason"
			prop="dropReason"
			value={dropReason}
			onInputChange={onChange}
			items={WITHDRAWAL_REASONS}
			hideUnknown={true}
			fullWidth={true}
			required={required}
		/>
	)
}

export default DropReason
